import React from 'react';
import PropTypes from 'prop-types';
import {GAME_SPACING} from './gameReviewUtils';

/**
 * Reusable grid row component for game review sections
 * Displays items in a 3-column grid layout
 */
export const GameReviewGridRow = ({
  items,
  dataTestId,
  preserveRhythm = false
}) => (
  <div
    className={`mt-3 grid ${GAME_SPACING.threeColGridClass}`}
    data-testid={dataTestId}>
    {items.map((item) =>
      item?.isSpacer ? (
        <div
          key={item.label || 'grid-spacer'}
          className='invisible pb-2'
          aria-hidden='true'
        />
      ) : (
        <div key={item.label} className='pb-2'>
          <p className='text-sm text-[#D0D0D0]'>{item.label}</p>
          <p className='font-bold text-white'>{item.value}</p>
        </div>
      )
    )}
    {preserveRhythm &&
      items.length < 3 &&
      Array.from({length: 3 - items.length}).map((_, idx) => {
        const paddingKey = `padding-${items.length}-${idx === 0 ? 'first' : 'second'}`;
        return (
          <div key={paddingKey} className='invisible pb-2' aria-hidden='true' />
        );
      })}
  </div>
);

GameReviewGridRow.propTypes = {
  items: PropTypes.array.isRequired,
  dataTestId: PropTypes.string,
  preserveRhythm: PropTypes.bool
};

/**
 * Single row wrapper for GameReviewGridRow
 * Useful for displaying a single label-value pair
 */
export const GameReviewSingleRow = ({label, value, dataTestId}) => (
  <GameReviewGridRow
    dataTestId={dataTestId}
    preserveRhythm
    items={[{label, value}]}
  />
);

GameReviewSingleRow.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.node,
  dataTestId: PropTypes.string
};

/**
 * Section title component for game review sections
 */
export const GameSectionTitle = ({
  label,
  className = '',
  showDivider = false
}) => (
  <div className={className}>
    <h3 className='text-base font-bold text-white'>{label}</h3>
    {showDivider && (
      <div className='mt-2 border-b border-[color:var(--color-border-divider)]' />
    )}
  </div>
);

GameSectionTitle.propTypes = {
  label: PropTypes.string.isRequired,
  className: PropTypes.string
};
